import { GET_SERVICE_PROVIDERS } from "./serviceproviders.constants";

export const getServiceProviders = (payload = {}, callback) => ({type: GET_SERVICE_PROVIDERS, payload, callback});